export default {
	'please-select-an-item': 'Please select an item'
}